import PropTypes from 'prop-types';

import ReviewsFactor from './ReviewsFactor';

import './ReviewsFactors.scss';

const ReviewsFactors = ({ factors }) => (
  <div className="reviews-factors">
    {factors.map((factor, index) => (
      <ReviewsFactor type={factor.type} rating={factor.rating} key={index} />
    ))}
  </div>
);

ReviewsFactors.propTypes = {
  factors: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      rating: PropTypes.number.isRequired
    })
  ).isRequired
};

export default ReviewsFactors;
